import React from 'react';
import { useRouter } from 'next/router';
import { Page as Component } from '~/components/specifics/vendors/403/Page';

export const Page: React.FC = () => {
  const router = useRouter();
  const { message } = router.query;
  return <Component message={String(message || '')} />;
};
